import React from 'react';
import path from 'path';
import { promises as fs } from 'fs';
import { AgenciesList } from '../../components/Views/AgenciesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { agenciesQuery } from '../../api/queries';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getSSRContextData } from '../../utils/helpers/ssrContext';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';

const Agencies = props => <AgenciesList {...props} />;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ({ req, query }) => {
    const { platform } = getSSRContextData(req);
    const currentLang = getLocaleOnSSR(req);

    const apolloClient = initApollo({}, { lang: currentLang, platform });
    const asPath = '/agentlikler';

    if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
      const filePath = path.join(
        process.cwd(),
        'cypress/mock',
        'agenciesMockData.json'
      );
      await fs.readFile(filePath, 'utf-8');

      return { props: {} };
    }

    const [seoData] = await Promise.all([
      getSeoData(apolloClient, asPath, req, true),
      apolloClient.query({
        query: agenciesQuery,
        fetchPolicy: 'network-only'
      }),
      getStaticData(apolloClient)
    ]);

    return {
      props: {
        seoData,
        hasError: false,
        currentLang,
        apolloCache: apolloClient.cache.extract()
      }
    };
  },
  '/agencies',

  context => {
    const currentLang = getLocaleOnSSR(context.req);

    return {
      seoData: {},
      hasError: true,
      apolloCache: null,
      currentLang
    };
  }
);

Agencies.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation
    isShowCloseButton={false}
    pageProps={pageProps}
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default Agencies;
